import { useState, useEffect, Dispatch, SetStateAction } from 'react';
import { defaultRankColors, RANK_COLORS_KEY } from '../services/rank-utils';
import { indexedDBStorage } from '../services/storage/indexedDB';

export function useRankColors(): [Record<string, string>, Dispatch<SetStateAction<Record<string, string>>>] {
  const [rankColors, setRankColors] = useState<Record<string, string>>(defaultRankColors);

  useEffect(() => {
    indexedDBStorage.getItem(RANK_COLORS_KEY)
      .then(stored => {
        if (stored) {
          try {
            setRankColors(JSON.parse(stored));
          } catch (error) {
            console.error('ランク色マッピングのパースエラー:', error);
          }
        }
      })
      .catch(error => {
        console.error('ランク色マッピングの読み込みエラー:', error);
      });
  }, []);

  return [rankColors, setRankColors];
}
